export default "__VITE_ASSET__CYwOdDnY__"